import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserPermissionService } from 'app/core/services/user-permission/user-permission.service';

@Directive({
  selector: '[appHasRight]',
})
export class HasRightDirective implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private rights: number[];
  private elseTemplateRef: TemplateRef<any> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userPermissionService: UserPermissionService,
  ) {}

  ngOnInit() {
    // Subscribe to the shared BehaviorSubject – no new OIDC subscription per directive instance.
    this.userPermissionService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateView();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @Input()
  set appHasRight(val: number[]) {
    this.rights = val;
    this.updateView();
  }

  @Input()
  set appHasRightElse(templateRef: TemplateRef<any> | null) {
    this.elseTemplateRef = templateRef;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    if (this.userPermissionService.hasAnyRight(this.rights)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.elseTemplateRef) {
      this.viewContainer.createEmbeddedView(this.elseTemplateRef);
    }
  }
}
